(() => {
  'use strict';
  // Legacy RC recommendations remain the fallback until the bundle UI renders.
  const watched = new WeakSet();
  function connect() {
    document.querySelectorAll('[data-hbe-product-block]').forEach(block => {
      if (watched.has(block)) return;
      watched.add(block);
      const scope = block.closest('.shopify-section');
      if (!scope) return;
      function reconcile() {
        const content = block.querySelector('[data-hbe-content]');
        content?.querySelectorAll('.hbe-offer-card').forEach(card => {
          const mainTitle = card.querySelector('.hbe-main-item .hbe-choice-title')?.textContent || '';
          const heading = card.querySelector('.hbe-title');
          if (mainTitle.includes('[4302V4T3]') && heading && heading.textContent !== 'Arrma Granite Bundle') {
            heading.textContent = 'Arrma Granite Bundle';
          }
          card.querySelectorAll('.hbe-choice-label').forEach(label => {
            if (label.textContent.trim().startsWith('Included')) label.remove();
          });
          card.querySelectorAll('.hbe-note').forEach(note => {
            if (note.textContent.trim() === 'Final savings are calculated automatically in your cart.') note.remove();
          });
        });
        const rendered = !block.hidden && content && !content.hidden && !!content.querySelector('.hbe-offer-card .hbe-actions button');
        scope.querySelectorAll('#block-rc_needed_products, #block-rc_you_might_like').forEach(legacy => {
          if (rendered) {
            if (!legacy.hasAttribute('data-hbe-suppressed')) {
              legacy.dataset.hbePreviousHidden = legacy.hidden ? 'true' : 'false';
              legacy.dataset.hbeSuppressed = 'true';
            }
            legacy.hidden = true;
          } else if (legacy.hasAttribute('data-hbe-suppressed')) {
            legacy.hidden = legacy.dataset.hbePreviousHidden === 'true';
            delete legacy.dataset.hbeSuppressed;
            delete legacy.dataset.hbePreviousHidden;
          }
        });
      }
      new MutationObserver(reconcile).observe(block, {subtree:true, childList:true, attributes:true, attributeFilter:['hidden']});
      reconcile();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once:true});
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();
